import { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useNavigate, useLocation } from "react-router-dom";
import { Button, Container, Grid, Stack, Typography, TextField, Chip, Checkbox, Select, OutlinedInput, MenuItem, useTheme, FormControl, FormControlLabel, FormLabel, RadioGroup, Radio, Paper, Tabs, Tab, Box } from "@mui/material";
// components
import Page from "../../components/Page";
import StringUtil from "src/utils/StringUtil";
import { alert } from "src/services/alert";
import { COMP_NAME } from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import { useSelector } from "react-redux";
// import { getProductCategories } from "src/services/request";
import PriceList from "src/components/PriceList";
import MyEditor from "src/components/editor/MyEditor";
import NavBack from "src/components/common/NavBack";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { getProductCategories } from "src/services/request";
import { asyncRequest } from "src/services/network";
import { InputAdornment } from "@mui/material";
import { Switch } from "@mui/material";
import MerchantPicker from "src/components/common/MerchantPicker";
import CouponPicker from "src/components/common/CouponPicker";

const TABS = [
  { label: "基本信息" },
  { label: "规格库存" },
  { label: "商品详情" },
  // { label: "物流设置" },
  { label: "营销设置" },
  { label: "支付方式" },
];

export default function ProductDetail() {
  const categories = useSelector((state) => state.globalData.productCategories) || [];
  const navigate = useNavigate();
  const item = useLocation().state || {};
  const { id } = useParams();
  const [category, setCategory] = useState({});

  const [detail, setDetail] = useState(item.detail);
  const [merchant, setMerchant] = useState(item.merchant || {});

  // console.log('categories', categories)

  const [tabIdx, setTabIdx] = useState("0");
  const [coupons, setCoupons] = useState([]);

  const [form, setForm] = useState({
    mid: item.mid,
    intro: item.intro || "",
    name: item.name || "",
    attrName: item.attrName || "",
    attrs: item.attrs || null,
    priceList: item.priceList || null,
    cover: item.cover || "",
    // coverHorizontal: item.coverHorizontal || "",
    images: item.images || "",
    categoryId: item.categoryId || 0, // 分类
    sectionId: item.sectionId || 1, // 优选区
    priceOriginal: item.priceOriginal || "",
    price: item.price || "",
    cost: item.cost || "",
    unit: item.unit || "件",
    status: item.status || 1,
    isFreeShipping: item.isFreeShipping !== undefined ? item.isFreeShipping : true,
    shippingFee: item.shippingFee || "",
    stock: item.stock || "",
    specType: item.specType || 0,
    points: item.points || 0,
    order: item.order || 0,
    // zhitui: item.zhitui || 0,
    priceSilver: item.priceSilver || 0,
    pricePlatinum: item.pricePlatinum || 0,
    priceSuper: item.priceSuper || 0,
    // jiantui: item.jiantui || 0,
    pointsMer: item.pointsMer || 0,
    profit: item.profit || 0,
    shares: item.shares || 0,
    isBaodan: item.isBaodan || false,
    directBuy: item.directBuy || false,
    enableVip: item.enableVip || false,
    // 支付途径限制位掩码：0=不限制 CASH=1 QXJ=2 XFQ=4 DHQ=8
    allowedPayMethods: item.allowedPayMethods ?? 1,
  });

  useEffect(() => {
    getProductCategories();
    if (item.coupons) {
      getCoupons();
    }
  }, []);

  useEffect(() => {
    console.log(category, categories);
    if (!categories || !categories.length || !item.categoryId || category.id) return;
    setCategory(categories.find((c) => c.id == item.categoryId) || {});
  }, [categories]);

  async function getCoupons() {
    const { data } = await asyncRequest({
      path: "/coupon/query",
      data: { ids: item.coupons.split(",") },
    });

    setCoupons(data);
  }

  // 选择框
  function handleSelect(type, event) {
    // console.log(type, event.target);
    if (type === "category") {
      setCategory(event.target.value);
      handleIptChange("categoryId", event.target.value.id);
    }
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handlePriceListChange(obj) {
    setForm({
      ...form,
      ...obj,
    });
  }

  async function handleSubmit() {
    const { specType, name, attrs, priceList } = form;
    if (!name) return alert("商品名称不能为空");
    if (!detail || !name) return alert("商品详情不能为空");
    if (specType && !attrs) return alert("多规格需添加规则");

    console.log(merchant);
    const formData = {
      ...form,
      mid: merchant.mid,
      detail,
      attrs: specType === 1 ? StringUtil.serialize(attrs) : null,
      priceList: specType === 1 ? StringUtil.serialize(priceList) : null,
      coupons: coupons.map((c) => c.id).join(","),
    };

    // console.log(form);

    if (id) {
      formData.id = id;
    }

    await asyncRequest({
      path: id ? "/store/product/edit" : "/store/product/add",
      data: formData,
    });

    navigate(-1, { replace: true });
  }

  function handleSelectMerchant(key) {
    MerchantPicker({
      onSelect(val) {
        console.log(val);
        setMerchant(val);
      },
    });
  }

  function handleSelectCoupon() {
    console.log("sdd");
    CouponPicker({
      title: "优惠券列表",
      onSelect(val) {
        console.log(val);
        setCoupons(val);
      },
    });
  }

  return (
    <Page title={`${id ? "编辑" : "添加"}商品 | ${COMP_NAME}`}>
      <Container maxWidth="2000px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <NavBack title={`${id ? "编辑" : "添加"}商品`} />
        </Stack>

        <Paper variant="outlined" sx={{ py: 1, pr: 3 }}>
          <TabContext value={tabIdx}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList onChange={(e, idx) => setTabIdx(idx)}>
                {TABS.map((t, idx) => (
                  <Tab key={t.label} label={t.label} value={String(idx)} />
                ))}
              </TabList>
            </Box>
            <TabPanel value="0">
              <FormItem title="所属区块" required>
                <Select value={form.sectionId} onChange={(e) => handleIptChange("sectionId", e.target.value)} style={{ width: 250, height: 44 }}>
                  {[1,2,3].map((sectionId, idx) => (
                    <MenuItem key={sectionId} value={sectionId} name={sectionId}>
                      {['', '热销区', '优选区', '精品区'][sectionId]}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>

              <FormItem title="商户">
                <TextField fullWidth placeholder="请选择商户" autoComplete="off" id="merchant" value={merchant.name || ""} size="small" onClick={() => handleSelectMerchant("mid")} />
              </FormItem>

              <FormItem title="商品分类" required>
                <Select value={category} onChange={(e) => handleSelect("category", e)} style={{ width: 250, height: 44 }}>
                  {categories.map((category, idx) => (
                    <MenuItem key={category.id} value={category} name={category.name}>
                      {category.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormItem>

              <FormItem title="商品名称" required>
                <TextField fullWidth placeholder="请输入商品名称" autoComplete="off" id="name" value={form.name} size="small" onChange={(e) => handleIptChange("name", e.target.value)} />
              </FormItem>

              <FormItem title="商品单位" required>
                <TextField fullWidth placeholder="请输入商品单位" autoComplete="off" id="unit" value={form.unit} size="small" onChange={(e) => handleIptChange("unit", e.target.value)} />
              </FormItem>

              <FormItem title="商品封面" required>
                <Stack>
                  <Uploader images={form.cover} onUploaded={(val) => handleIptChange("cover", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：400x400
                  </Typography>
                </Stack>
              </FormItem>
              {/* 
              <FormItem title="横向封面">
                <Stack>
                  <Uploader images={form.coverHorizontal} onUploaded={(val) => handleIptChange("coverHorizontal", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：320x180
                  </Typography>
                </Stack>
              </FormItem> */}

              <FormItem title="商品轮播图" required>
                <Stack>
                  <Uploader multiple images={form.images} onUploaded={(val) => handleIptChange("images", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：400x400
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="商品详情图" required>
                <Stack>
                  <Uploader multiple images={form.detailImages} onUploaded={(val) => handleIptChange("detailImages", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：400x400
                  </Typography>
                </Stack>
              </FormItem>

              <FormItem title="商品状态" required>
                <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
                  <FormControlLabel value={1} control={<Radio />} label="上架" onChange={(e) => handleIptChange("status", e.target.value)} />
                  <FormControlLabel value={0} control={<Radio />} label="下架" onChange={(e) => handleIptChange("status", e.target.value)} />
                </RadioGroup>
              </FormItem>

              <FormItem title="是否直接购买">
                <Switch checked={form.directBuy} onChange={(e) => handleIptChange("directBuy", e.target.checked)} />
              </FormItem>

              <FormItem title="排序">
                <TextField placeholder="数字越大越靠前" type="number" autoComplete="off" id="order" value={form.order} size="small" onChange={(e) => handleIptChange("order", e.target.value)} />
              </FormItem>

              <FormItem spacing={1}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setTabIdx(Number(tabIdx) + 1 + "");
                  }}
                >
                  下一步
                </Button>
              </FormItem>
            </TabPanel>
            <TabPanel value="1">
              <FormItem title="商品规格" required>
                <RadioGroup row name="row-radio-buttons-group" value={form.specType} onChange={(e) => handleIptChange("specType", parseInt(e.target.value))}>
                  <FormControlLabel value={0} control={<Radio />} label="单规格" />
                  <FormControlLabel value={1} control={<Radio />} label="多规格" />
                </RadioGroup>
              </FormItem>

              {form.specType === 0 && (
                <>
                  <FormItem title="商品原价">
                    <TextField fullWidth type="number" placeholder="请输入商品原价" autoComplete="off" id="priceOriginal" value={form.priceOriginal} size="small" onChange={(e) => handleIptChange("priceOriginal", e.target.value)} />
                  </FormItem>

                  <FormItem title="商品成本价">
                    <TextField fullWidth type="number" placeholder="请输入商品成本价" autoComplete="off" id="cost" value={form.cost} size="small" onChange={(e) => handleIptChange("cost", e.target.value)} />
                  </FormItem>

                  <FormItem title="商品售价" required>
                    <TextField fullWidth type="number" placeholder="请输入商品售价" autoComplete="off" id="price" value={form.price} size="small" onChange={(e) => handleIptChange("price", e.target.value)} />
                  </FormItem>

                  {/* <FormItem title="所需积分">
                    <TextField fullWidth type="number" placeholder="请输入所需积分" autoComplete="off" id="pointsNeeded" value={form.pointsNeeded} size="small" onChange={(e) => handleIptChange("pointsNeeded", e.target.value)} />
                  </FormItem> */}

                  <FormItem title="商品库存" required>
                    <TextField fullWidth type="number" placeholder="请输入商品库存，不填则无限" autoComplete="off" id="stock" value={form.stock} size="small" onChange={(e) => handleIptChange("stock", e.target.value)} />
                  </FormItem>
                </>
              )}

              {form.specType === 1 && (
                <FormItem title="选择规格" required>
                  <PriceList defaultAttrName={form.attrName} defaultAttrs={form.attrs} defaultPriceList={form.priceList} onChange={handlePriceListChange} />
                </FormItem>
              )}

              {/* <FormItem title="是否开启等级价格">
                <Switch checked={form.enableVip} onChange={(e) => handleIptChange("enableVip", e.target.checked)} />
              </FormItem>

              {form.enableVip && (
                <>
                  <FormItem title="银卡价" required>
                    <TextField fullWidth type="number" placeholder="请输入银卡价" autoComplete="off" id="priceSilver" value={form.priceSilver} size="small" onChange={(e) => handleIptChange("priceSilver", e.target.value)} />
                  </FormItem>

                  <FormItem title="铂金卡价" required>
                    <TextField fullWidth type="number" placeholder="请输入铂金卡价" autoComplete="off" id="pricePlatinum" value={form.pricePlatinum} size="small" onChange={(e) => handleIptChange("pricePlatinum", e.target.value)} />
                  </FormItem>

                  <FormItem title="超级年卡价" required>
                    <TextField fullWidth type="number" placeholder="请输入超级年卡价" autoComplete="off" id="priceSuper" value={form.priceSuper} size="small" onChange={(e) => handleIptChange("priceSuper", e.target.value)} />
                  </FormItem>
                </>
              )} */}

              <FormItem spacing={1}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setTabIdx(Number(tabIdx) + 1 + "");
                  }}
                >
                  下一步
                </Button>
              </FormItem>
            </TabPanel>

            <TabPanel value="2">
              <Paper variant="outlined" sx={{ paddingX: 2, paddingY: 1, flex: 1, minHeight: 220 }}>
                <MyEditor
                  html={detail}
                  onChange={(val) => {
                    setDetail(val);
                  }}
                />
              </Paper>

              <FormItem spacing={1}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setTabIdx(Number(tabIdx) + 1 + "");
                  }}
                >
                  下一步
                </Button>
              </FormItem>
            </TabPanel>

            {/* 营销 */}
            <TabPanel value="3">
              {/* <FormItem title="直推比例" required>
                <TextField
                  placeholder="请输入直推比例"
                  autoComplete="off"
                  id="zhitui"
                  value={form.zhitui}
                  size="small"
                  onChange={(e) => handleIptChange("zhitui", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment>%</InputAdornment>,
                  }}
                />
              </FormItem>
              <FormItem title="间推比例" required>
                <TextField
                  type="number"
                  placeholder="请输入间推比例"
                  autoComplete="off"
                  id="jiantui"
                  value={form.jiantui}
                  size="small"
                  onChange={(e) => handleIptChange("jiantui", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment>%</InputAdornment>,
                  }}
                />
              </FormItem> */}

              {/* <FormItem title="是否是报单商品">
                <Switch checked={form.isBaodan} onChange={e => handleIptChange('isBaodan', e.target.checked)} />
              </FormItem> */}

              {/* <FormItem title="直推奖励">
                <TextField type="number" placeholder="请输入直推奖励" autoComplete="off" id="zhitui" value={form.zhitui} size="small" onChange={(e) => handleIptChange("zhitui", e.target.value)} />
              </FormItem> */}

              <FormItem title="赠送用户积分" required>
                <TextField placeholder="请输入赠送用户积分" autoComplete="off" id="points" value={form.points} size="small" onChange={(e) => handleIptChange("points", parseFloat(e.target.value) || 0)} />
              </FormItem>

              <FormItem title="赠送商户积分" required>
                <TextField placeholder="请输入赠送商户积分，不填默认同用户积分" autoComplete="off" id="pointsMer" value={form.pointsMer} size="small" onChange={(e) => handleIptChange("pointsMer", parseFloat(e.target.value) || 0)} />
              </FormItem>

              <FormItem title="利润池数额" required>
                <TextField placeholder="请输入利润池数额" autoComplete="off" id="profit" value={form.profit} size="small" onChange={(e) => handleIptChange("profit", parseFloat(e.target.value) || 0)} />
              </FormItem>

          
              <FormItem title="赠送优惠券" required>
                <Stack>
                  {coupons.map((c, i) => (
                    <Typography key={i}>{c.name}</Typography>
                  ))}
                  <Button variant="contain" color="primary" onClick={handleSelectCoupon}>
                    添加优惠券
                  </Button>
                </Stack>
              </FormItem>

              <FormItem>
                <Button variant="contained" type="submit" onClick={handleSubmit}>
                  确认{id ? "修改" : "添加"}
                </Button>
              </FormItem>
            </TabPanel>

            {/* 支付方式 */}
            <TabPanel value="4">
              <FormItem title="允许的支付方式">
                <Stack spacing={1}>
                  {[
                    { label: '现金支付（快捷支付）', bit: 1, desc: 'CASH=1' },
                    { label: '权益金支付', bit: 2, desc: 'QXJ=2' },
                    { label: '消费券抜扣', bit: 4, desc: 'XFQ=4' },
                    { label: '兑换券支付', bit: 8, desc: 'DHQ=8' },
                  ].map(({ label, bit, desc }) => (
                    <FormControlLabel
                      key={bit}
                      label={
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>{label}</Typography>
                          <Typography fontSize={12} color="gray">{desc}</Typography>
                        </Stack>
                      }
                      control={
                        <Checkbox
                          checked={(form.allowedPayMethods & bit) !== 0}
                          onChange={(e) => {
                            const next = e.target.checked
                              ? form.allowedPayMethods | bit
                              : form.allowedPayMethods & ~bit;
                            handleIptChange('allowedPayMethods', next);
                          }}
                        />
                      }
                    />
                  ))}
                </Stack>
                <Typography fontSize={12} color="gray" mt={1}>
                  当前位掩码值：<strong>{form.allowedPayMethods}</strong>（0 表示不限制）
                </Typography>
              </FormItem>

              <FormItem>
                <Button variant="contained" type="submit" onClick={handleSubmit}>
                  确认{id ? "修改" : "添加"}
                </Button>
              </FormItem>
            </TabPanel>
          </TabContext>

          {/* <FormItem title="商家" required>
            <Select value={merchant} onChange={(e) => handleSelect("merchant", e)} style={{ width: 250, height: 44 }}>
              {merchants.map((merchant, idx) => (
                <MenuItem key={merchant.mid} value={merchant} name={merchant.name}>
                  {merchant.name}
                </MenuItem>
              ))}
            </Select>
          </FormItem> */}

          {/* <FormItem title="运费成本" required>
            <TextField fullWidth type="number" placeholder="请输入运费成本" autoComplete="off" id="shippingFee" value={form.shippingFee} size="small" onChange={(e) => handleIptChange("shippingFee", e.target.value)} />
          </FormItem> */}

          {/* <FormItem title="是否包邮" required>
            <RadioGroup row name="row-radio-buttons-group" value={form.isFreeShipping} onChange={(e) => handleIptChange("isFreeShipping", parseInt(e.target.value))}>
              <FormControlLabel value={0} control={<Radio />} label="否" />
              <FormControlLabel value={1} control={<Radio />} label="是" />
            </RadioGroup>
          </FormItem> */}

          {/* {!form.isFreeShipping && (
            <FormItem title="邮费" required>
              <TextField fullWidth placeholder="请输入邮费" autoComplete="off" id="shippingFee" value={form.shippingFee} size="small" onChange={(e) => handleIptChange("shippingFee", e.target.value)} />
            </FormItem>
          )} */}

          {/* <FormItem title="商品简介">
            <TextField fullWidth placeholder="请输入商品简介" autoComplete="off" id="intro" value={form.intro} size="small" onChange={(e) => handleIptChange("intro", e.target.value)} />
          </FormItem> */}
        </Paper>
      </Container>
    </Page>
  );
}
